import { memo, ReactElement } from 'react';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withProcessesData } from 'components/common/withProcessesData';
import { MemoSingleContract } from 'components/contract/Single';
import {
  useContract,
  withContract,
} from 'components/dataProviders/withContract';
import { Spinner } from 'components/core';

function SingleContractView(): ReactElement {
  const { contract, loading } = useContract();

  if (loading || !contract) {
    return <Spinner reason='SingleContractView loading || !contract' />;
  }

  return <MemoSingleContract contract={contract} />;
}

export const MemoContract = memo(
  composeHOCs(withProcessesData, withContract)(
    SingleContractView
  )
);
